import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";

/**
 * Transform layer: clears selected region for each selected frame
 */
export default class CanvasEraser extends AbstractCanvasTransformTool {
	constructor() {
		super();
		this._needImageCenterResearch = false;
	}

	/**
	 * @param {HTMLCanvasElement} canvas
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {HTMLImageElement} img
	 * @returns {?T_DataSetItem}
	 * @protected
	 */
	_processImage(canvas, ctx, img, frameIndex) {
		ctx.clearRect(0, 0, this._sceneWidth, this._sceneHeight);
		ctx.save();
		ctx.drawImage(img, 0, 0);
		this._sel.clearSelectionInCanvas(ctx);
		ctx.restore();

		return this._dataSet.setData(canvas.toDataURL('image/png'));
	}
}
